import { Skeleton } from '@/ui/components/skeleton/skeleton';
import { PlotSection } from '@/warranty-v3/components/plot-section';
import { TableSkeleton } from '@/warranty-v3/components/table-skeleton';
import { Card, CardContent } from '@/warranty-v3/components/ui/card';

export function DataLoading() {
  return (
    <>
      {/* Overview Table Loading */}
      <PlotSection sectionName="Overview Table">
        <Card className="w-full overflow-x-auto">
          <CardContent>
            {/* Table skeleton */}
            <TableSkeleton columns={6} rows={8} />
          </CardContent>
        </Card>
      </PlotSection>

      {/* Warranty Penalties Loading */}
      <PlotSection sectionName="Penalty Overview">
        <Card className="w-full overflow-x-auto">
          <CardContent>
            <div className="flex flex-row gap-x-10">
              {/* Chart skeleton */}
              <div className="h-96 w-2/5 shrink-0">
                <div className="size-full rounded-lg border border-gray-200 bg-white p-4">
                  <div className="mb-4">
                    <Skeleton className="h-6 w-32" />
                  </div>
                  <div className="space-y-4">
                    {Array.from({ length: 6 }).map((_, i) => (
                      <div key={i} className="flex items-center space-x-3">
                        <Skeleton className="h-3 w-16 shrink-0" />
                        <Skeleton
                          className="h-6 bg-gray-200"
                          style={{ width: `${30 + Math.random() * 60}%` }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Table skeleton */}
              <div className="h-96 w-full grow">
                <TableSkeleton columns={4} rows={8} />
              </div>
            </div>
          </CardContent>
        </Card>
      </PlotSection>

      {/* Condition Violations Loading */}
      <PlotSection sectionName="Condition Violations">
        <Card className="w-full overflow-x-auto">
          <CardContent>
            <div className="flex flex-row gap-x-10">
              {/* Chart skeleton */}
              <div className="h-96 w-2/5 shrink-0">
                <div className="size-full rounded-lg border border-gray-200 bg-white p-4">
                  <div className="mb-4">
                    <Skeleton className="h-6 w-32" />
                  </div>
                  <div className="flex h-80 items-end justify-around space-x-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <div
                        key={i}
                        className="flex flex-col items-center space-y-1"
                      >
                        <Skeleton
                          className="w-10 bg-gray-200"
                          style={{ height: `${40 + Math.random() * 140}px` }}
                        />
                        <Skeleton className="h-3 w-8" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Table skeleton */}
              <div className="h-96 w-2/5 grow">
                <TableSkeleton columns={4} rows={8} />
              </div>
            </div>
          </CardContent>
        </Card>
      </PlotSection>
    </>
  );
}
